import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import { IFormSection, TFormHookParams } from "../../types/common";
import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { beautify } from "../../utils/helpers";
import { URL_BOOKING_TYPE_CONFIGURABLE } from "../../utils/urls";
import useGet from "../common/useGet";
import { API_BOOKING_TYPE_CONFIGURABLE, API_DISTRICTS } from "../../utils/apis";
import { BOOKING_TYPE_CONFIGURABLE } from "../../utils/constants";

const useBookingTypeConfigurable = () => {
  const tableColumns = () => [
    ...["name", "city_names", "key", "actions"].map((item) =>
      createColumn(
        item,
        item === "actions" || item === "city_names" ? false : true,
        beautify(item),
      ),
    ),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data.map((item: any) => ({
      ...item,
      key: item.key,
      actions: (
        <FormActions
          actions={[createEditAction(URL_BOOKING_TYPE_CONFIGURABLE, item?.id)]}
        />
      ),
    }));
  };

  const formRoute = getForm(URL_BOOKING_TYPE_CONFIGURABLE);
  const activityFilter = "booking_type_configurable";

  return { tableColumns, tableData, formRoute, activityFilter };
};

export const useBookingTypeConfigurableForm = ({
  id,
  updateFormValues,
}: TFormHookParams = {}) => {
  const { loadData, loading, data } = useGet();
  const { loadData: getDistricts, data: districts } = useGet();

  useEffect(() => {
    loadData({ api: API_BOOKING_TYPE_CONFIGURABLE });
    getDistricts({ api: API_DISTRICTS });
  }, []);

  useEffect(() => {
    if (updateFormValues) {
      updateFormValues({
        booking_type_configurable: BOOKING_TYPE_CONFIGURABLE,
      });
    }
  }, [updateFormValues]);

  const isEdit = !!id;

  const sections: IFormSection[] = [
    {
      title: "Booking Type Configurable Details",
      fields: [
        {
          field_name: "key",
          type: "text",
          props: { required: true, placeholder: "Enter key", disabled: isEdit },
        },
        {
          field_name: "name",
          label: "Name",
          type: "text",
          props: {
            required: true,
            placeholder: "Enter name",
            disabled: isEdit,
          },
        },
        {
          field_name: "city",
          label: "City",
          type: "select",
          props: { required: true, multiple: true },
          options_data: districts,
        },
      ],
    },
  ];

  const title = "Booking Type Configurable";
  const redirect = getRegister(URL_BOOKING_TYPE_CONFIGURABLE);

  const onSubmit = (payload: any, id: string) => {
    if (id) {
      return {
        id,
        api: API_BOOKING_TYPE_CONFIGURABLE,
        params: {
          ...payload,
        },
      };
    }
    return {
      api: API_BOOKING_TYPE_CONFIGURABLE,
      params: {
        ...payload,
      },
    };
  };

  return { sections, title, redirect, loading, onSubmit, data };
};

export default useBookingTypeConfigurable;
